//setup module
var sessionModule = angular.module('session',['property']);
var session = {};
session.sid = (typeof sid === 'undefined') ? null : sid;
session.firstRoom = 0;
session.isLoading = false;
session.badBrowser = false;
session.promoWasValid = false;
session.selectedFilters = {};
session.marketingGroupCounts = [];
session.forceRoomRefresh = false;
session.locationPath = '';
var passedStart = (typeof passedStart === 'undefined') ? null : passedStart;
session.selectedFilters.checkin = passedStart ? moment(passedStart,'YYYY-MM-DD').toDate() : null;
session.selectedFilters.nights = (typeof defaultStay === 'undefined') ? null : defaultStay;
session.selectedFilters.checkout = new Date();
if(session.selectedFilters.checkin){
    session.selectedFilters.checkout = moment(session.selectedFilters.checkin).add(session.selectedFilters.nights, 'days').toDate();
}
if(typeof isItemOnly !== 'undefined' && isItemOnly){
    session.selectedFilters.checkin = moment().toDate();
    session.selectedFilters.checkout = moment(session.selectedFilters.checkin).add(1,'Day').toDate();
}
session.selectedFilters.rooms = 1;
session.selectedFilters.adults = 1;
session.selectedFilters.children = null;
session.selectedFilters.infants = null;
session.selectedFilters.groupFilters = (typeof defaultGroupPaxAmounts === 'undefined') ? null : defaultGroupPaxAmounts;
session.selectedFilters.currency = (typeof defaultCurrency === 'undefined') ? null : defaultCurrency;

session.locals = (typeof global_locales === 'undefined') ? null : global_locales;
session.showToast = false;
session.toastMessage = 'Welcome';

session.promoCodeDiscounts = [];
session.usedPromoCodes = [];
session.discountLabel = "Discounts";
session.getPromoCodeDiscountTotal = function(){
    var total = 0;
    angular.forEach(session.promoCodeDiscounts, function(discount){
        total += discount;
    });
    return total;
};
session.checkPromoCodeUsed = function(promoCode){
    var beenUsed = false;
    angular.forEach(session.usedPromoCodes, function(usedCode){
        if(usedCode === promoCode){
            beenUsed = true;
        }
    });
    return beenUsed;
};

session.loadMore = {};
session.loadMore.rooms = true;
session.loadMore.extras = true;

// seller entities
session.sellerEntityId = (typeof sellerEntityId === 'undefined') ? null : sellerEntityId;
session.sellerEntityName = (typeof sellerEntityName === 'undefined') ? null : sellerEntityName;
session.isAgent = (typeof isAgent === 'undefined') ? null : isAgent;
session.sellerEntityValidationType = (typeof sellerEntityValidationType === 'undefined') ? null : sellerEntityValidationType;
session.agentLoginTemplateText = (typeof agentLoginTemplateText === 'undefined') ? null : agentLoginTemplateText;

session.selectedRooms = [];
session.errors = [];
session.maxUniquenessReached = [];

// cart index of the room currently being configured
session.configureRoomIndex = 0;
// filters form
session.filtersForm = {};
session.filtersForm.isValid = false;
session.filterRooms = (typeof roomsToFilter === 'undefined') ? null : roomsToFilter;
session.filterRates = (typeof ratesToFilter === 'undefined') ? null : ratesToFilter;

session.displayAgentLoginLink = (typeof displayAgentLoginLink === 'undefined') ? false : displayAgentLoginLink;

// lead guest form
session.leadGuestForm = {};
session.leadGuestForm.isValid = false;
session.leadGuestForm.guestNamesValid = false;
session.leadGuestForm.ETAValid = false;
session.leadGuestForm.previouslyHandled = false;
session.howFound = (typeof howFound === 'undefined') ? null : howFound;
session.confirmClose = (typeof confirmClose === 'undefined') ? null : confirmClose;
session.showConfirmCloser = false;
session.insuranceError = false;

// error handler specifics
session.errorHandler = {};
session.errorHandler.showError = false;
session.errorHandler.message = 'show the error here';
session.errorHandler.errorTitle = 'Whoops...';

session.viewingRoom = 0;
session.viewingPhoto = 0;
session.viewingPropPhoto = 0;
session.booking = (typeof booking === 'undefined') ? null : booking;
session.booking.leadGuest.addressLookup = '';
session.booking.leadGuest.addressShow = (typeof addressAutoCompleteProvider !== 'undefined' && addressAutoCompleteProvider) ? false : true;
session.countries = (typeof countries === 'undefined') ? null : countries;
session.template = (typeof template === 'undefined') ? null : template;
session.paxLabels = (typeof paxLabels === 'undefined') ? null : paxLabels;
session.propertyClosedOnStartDate = false;
session.propertyClosedOnEndDate = false;
session.propertyClosedMessage = null;
session.customFields = (typeof customFields === 'undefined') ? null : customFields;
session.bookingCustomFields = (typeof bookingCustomFields === 'undefined') ? null : bookingCustomFields;
session.bookingCustomValues = {};
session.leadGuestCustomFields = (typeof leadGuestCustomFields === 'undefined') ? null : leadGuestCustomFields;
session.leadGuestForm.leadGuestCustomValues = {};
session.customFieldTypes = (typeof customFieldTypes === 'undefined') ? null : customFieldTypes;
session.payment = {required: false};
session.paymentContact = (typeof paymentContact === 'undefined') ? null : paymentContact;

session.timer = {payment: {progress: 0, complete: true}};
session.paymentOptions = {};
session.suggestedDeposit = 0;
session.allowFullPayment = (typeof template === 'undefined' || typeof template.fullPayment === 'undefined') ? null : template.fullPayment;
session.isDepositOrFullPayment = (typeof isDepositOrFullPayment === 'undefined') ? null : isDepositOrFullPayment;
session.captureCreditCard = false;
session.creditCardFee = 1;
session.roomGroupIndex = 0;
session.hasEmailSettings = (typeof hasEmailSettings === 'undefined') ? null : hasEmailSettings;

session.loadingWarning = {
    show: false,
    warning: null
};

if(session.bookingCustomFields.constructor !== null){
    _.each(session.bookingCustomFields, function(customField){
        // Build a custom values template for each custom field
        session.bookingCustomValues[customField.id] = {id: null,rawValue: null,value: null}
    });
}
if(session.leadGuestCustomFields.constructor !== null && session.booking.leadGuest.constructor !== null){
    session.booking.leadGuest.customValues = {};
    _.each(session.leadGuestCustomFields, function(customField){
        // Build a custom values template for each custom field
        session.booking.leadGuest.customValues[customField.id] = {id: null,rawValue: null,value: null}
    });
}

// define session service
sessionModule.factory('sessionFactory',function(){
    var user = session;
    return user;
});

// selected Room details
session.selectedRoom = {};
session.selectedRoom.basePax = 0;
session.selectedRoom.maxAdditionalPax = 0;
session.selectedRoom.maxPax = session.selectedRoom.basePax + session.selectedRoom.maxAdditionalPax;
session.selectedRoom.selectedAdults = session.selectedRoom.basePax;
session.selectedRoom.selectedChildren = 0;
session.selectedRoom.selectedInfants = 0;
session.selectedRoom.remainingPax = {};
session.selectedRoom.remainingPax.adults = 0;
session.selectedRoom.remainingPax.children = 0;
session.selectedRoom.remainingPax.infants = 0;
session.selectedRoom.remainingPax.overall = 0;
session.selectedRoom.customValues = {};

// properties - for multi prop
if((!(typeof isMultiProp === 'undefined')) && isMultiProp) {
    session.getFilteredOnValues = function(filterLabel){
        var selected = null;
        selected = [];
        angular.forEach(session.propertyFilters.filters, function(filter){
            if(filter.label === filterLabel){
                if(filter.filteredOn){
                    angular.forEach(session.propertyFilters.filters, function(filterOn){
                        if(filterOn.label === filter.filteredOn){
                            angular.forEach(filterOn.selected, function(selectedOp){
                                switch(filter.filteredOn){
                                    case "Location":
                                        var countryRegions = session.propertyFilters.mapping.countryRegion[selectedOp];
                                        angular.forEach(countryRegions, function(region){
                                            if(!(selected.indexOf(region) > -1)){
                                                selected.push(region);
                                            }
                                        });
                                        break;
                                    case "City / Region":
                                        var cityRegions = session.propertyFilters.mapping.regionSubRegion[selectedOp];
                                        angular.forEach(cityRegions, function(region){
                                            if(!(selected.indexOf(region) > -1)){
                                                selected.push(region);
                                            }
                                        });
                                        break;
                                }
                            });
                            return selected;
                        }
                    });
                    return selected;
                } else {
                    return selected;
                }
            }
        });
        if(Array.isArray(selected) && selected.length === 0){
            return null;
        }
        return selected;
    };
    session.propertyFilters = {
        displayed: false,
        mapping: {},
        filters: [
            {
                label: 'Country',
                options: {},
                filteredOn: null,
                selected: [],
                multi: true,
                enabled: true
            },
            {
                label: 'City / Region',
                options: {},
                filteredOn: 'Country',
                selected: [],
                multi: true,
                enabled: true
            },
            {
                label: 'Location',
                options: {},
                filteredOn: 'City / Region',
                selected: [],
                multi: true,
                enabled: true
            },
            {
                label: 'Property Type',
                options: {},
                filteredOn: null,
                selected: [],
                multi: true,
                enabled: session.template.showPropertyType === 1
            },
            {
                label: 'Rating',
                options: {
                    '': 'All Ratings',
                    '1': 'At least 1 Star',
                    '1.5': 'At least 1.5 Stars',
                    '2': 'At least 2 Stars',
                    '2.5': 'At least 2.5 Stars',
                    '3': 'At least 3 Stars',
                    '3.5': 'At least 3.5 Stars',
                    '4': 'At least 4 Stars',
                    '4.5': 'At least 4.5 Stars',
                    '5': 'At least 5 Stars'
                },
                filteredOn: null,
                selected: '',
                multi: false,
                enabled: session.template.showPropertyRating === 1
            },
            {
                label: 'Facilities',
                options: {},
                filteredOn: null,
                selected: [],
                multi: true,
                enabled: session.template.showPropertyFeatures === 1
            },
            {
                label: 'Additional Options',
                options: propertyCategories,
                filteredOn: null,
                selected: [],
                multi: true,
                enabled: session.template.showPropertyCategories === 1
            }
        ]
    };

    session.propertyCategoryMapping = propertyCategoryMapping;
    session.propertyTypes = propertyTypes;
    session.propertyPhotos = propertyPhotos;
}

session.propertyCloseDates = [];
session.bookingMade = false;
var date = moment(minDate);
session.minCheckin = date.format('YYYY-MM-DD');
date.add(5,'years');
session.maxCheckin = date.format('YYYY-MM-DD');
if(moment(session.maxCheckin).isBefore(moment(session.selectedFilters.checkin))){
    session.selectedFilters.checkin = moment(session.maxCheckin).toDate();
}
session.titles = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Prof', 'Mx'];

if((typeof ngInTesting !== 'undefined') && ngInTesting){
    session = ngTesting.getTestSession();
}

// wholesale specific settings
session.redirectWholesale = redirectFromWholesaler;
